<template>
	<div>
		<!-- 忘记密码 -->
		<div class="changeHead">
			<labelInput spanTitle="原密码" v-if="reFresh" specilType="password" normalPlace="请输入原密码"
				@inputChange="labelInput" componentWidth="1000px"></labelInput>
			<labelInput spanTitle="新密码" v-if="reFresh" specilType="password" normalPlace="密码长度6-24位，至少包含字母、数字、字符任意两种组合"
				@inputChange="labelInput1" componentWidth="1000px"></labelInput>
			<labelInput spanTitle="确认新密码" v-if="reFresh" specilType="password" normalPlace="请确认新密码"
				@inputChange="labelInput2" componentWidth="1000px"></labelInput>
		</div>
		<div class="changeBtn">
			<el-button @click="resetSubmit">重置</el-button>
			<el-button type="primary" @click="submitReset">提交</el-button>
		</div>
	</div>

	</div>
</template>

<script>
	import {
		changePassword,
	} from '../../api/moudles/user.js'
	import labelInput from '../../components/table/labelInput.vue'

	export default {
		data() {
			return {
				componentWidth: '740px',
				oldPwd: '',
				newPwd: '',
				newPwd2: '',
				reFresh: true
			}
		},
		components: {
			labelInput,
		},
		methods: {
			// 发票申请
			invoice() {
				this.dialogVisible = true
			},
			labelInput(e) {
				this.oldPwd = e
			},
			labelInput1(e) {
				this.newPwd = e
			},
			labelInput2(e) {
				this.newPwd2 = e
			},
			// 重置
			resetSubmit() {
				this.reFresh = false
				this.oldPwd = ''
				this.newPwd = ''
				this.newPwd2 = ''
				setTimeout(() => {
					this.reFresh = true
				}, 0)
			},
			// 提交
			submitReset() {
				// 必填
				if (!this.oldPwd || !this.newPwd || !this.newPwd2) {
					this.$message.error('密码必填')
					return
				}
				// 密码验证
				if (this.newPwd.length > 5) {
					const rgx = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
					if (!rgx.test(this.newPwd)) {
						this.$message.error('密码不符合要求')
						return
					}
				} else {
					this.$message.error('密码长度不低于6位')
					return
				}
				// 两次输入不一致
				if (this.newPwd != this.newPwd2) {
					this.$message.error('两次新密码输入不一致')
					return
				}
				changePassword({
					data: {
						oldPwd: this.oldPwd,
						newPwd: this.newPwd
					},
					success: (res) => {
						if (res.code === 200) {
							this.$message({
								message: res.msg,
								type: 'success'
							});
							setTimeout(() => {
								localStorage.removeItem('token')
								this.$router.replace('/')
							}, 1000)
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			}
		}
	}
</script>

<style scoped>
	.changeHead {
		width: 1000px;
		margin-top: 40px;
		margin-left: auto;
		margin-right: auto;
	}

	.changeBtn button {
		margin-top: 30px;
		width: 130px;
		height: 42px;
		border-radius: 2px;
	}

	/* 新增表单 */
	/* 表单主体 */
	.form_body {
		width: 1250px;
		margin-left: auto;
		margin-right: auto;
		height: 100%;
	}

	.form_body2 {
		width: 1250px;
		height: 185px;

		display: flex;
		flex-flow: column;
		flex-wrap: wrap;
	}

	.form_body3 {
		min-height: 120px;
		height: auto;
		display: flex;
		align-items: flex-start;
		padding: 10px 0;
	}

	.tbody {
		margin-top: 20px;
		padding: 30px 0;
	}

	.form_button {
		height: 150px;
		display: flex;
		justify-content: center;
	}

	.form_button button {
		margin-top: auto;
		margin-bottom: auto;
		width: 200px;
		height: 35px;
		background-color: #015aaa;
	}

	.body_inner {
		width: 50%;
	}

	.p-title {
		color: #035bab;
		font-size: 16px;
		font-weight: 600;
		text-align: left;
	}

	/* 详情 */
	.labelChange {
		display: flex;
		width: 800px;
		height: 50px;
		line-height: 50px;
	}

	.labelChange span {
		display: block;
		width: 120px;
		text-align: right;

		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 600;
		color: #333333;
	}

	.labelChange p {
		display: block;
		width: 280px;
		text-align: left;
		padding-left: 20px;

		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 500;
		color: #1890FF;
	}
</style>
